export default function (fieldsSorting, fieldSortingDirections) {
  const getSortingDirection = (value) => (value ? 'desc' : 'asc');
  return fieldsSorting.reduce((acc, fieldSorting, index) => ({
    ...acc,
    [fieldSorting]: getSortingDirection(fieldSortingDirections[index]),
  }), {});
}
